import { render } from "preact";
import { BookOpen, Home, TrendingUp, Waves } from "lucide-preact";
import "./styles/fonts.css";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/components.css";
import "./styles/screens.css";
import "./styles/booth.css";
import "./styles/library.css";
import "./styles/progress.css";
import "./styles/settings.css";
import "./styles/onboarding.css";
import "./lib/theme";
import { TabBar } from "./components";
import type { TabItem } from "./components";
import { Booth } from "./booth/Booth";
import { KitchenSink } from "./dev/KitchenSink";
import { navigate, route } from "./lib/router";
import { Library } from "./screens/Library";
import { Onboarding } from "./screens/Onboarding";
import { ProgressScreen } from "./screens/Progress";
import { Settings } from "./screens/Settings";
import { SoundMap } from "./screens/SoundMap";
import { Today } from "./screens/Today";
import { activeSession, endSession } from "./state/session";
import { profile } from "./state/store";

const TABS: TabItem[] = [
  { id: "today", label: "Today", icon: Home },
  { id: "library", label: "Library", icon: BookOpen },
  { id: "map", label: "Map", icon: Waves },
  { id: "progress", label: "Progress", icon: TrendingUp },
];

function Screen() {
  switch (route.value) {
    case "library":
      return <Library />;
    case "map":
      return <SoundMap />;
    case "progress":
      return <ProgressScreen />;
    case "settings":
      return <Settings />;
    default:
      return <Today />;
  }
}

function App() {
  const active = route.value === "settings" || route.value === "onboarding" ? "today" : route.value;
  const session = activeSession.value;
  return (
    <div class="app-shell u-scanlines">
      <Screen />
      <TabBar items={TABS} activeId={active} onSelect={(id) => navigate(id as typeof route.value)} />
      {session && <Booth type={session} onExit={endSession} />}
    </div>
  );
}

function Root() {
  if (location.pathname.startsWith("/__kitchen")) return <KitchenSink />;
  if (!profile.value.seen.onboarded) return <Onboarding onDone={() => {}} />;
  return <App />;
}

render(<Root />, document.getElementById("app")!);
